<template>
<div class="container">

<h1><b-icon icon="person-square"></b-icon> Trial Registration
<div class="float-right" style="margin-top: -62px;">


  <b-button v-b-modal.modal-help v-b-tooltip.hover title="Help" class="help"> <b-icon icon="question-square-fill" ></b-icon> Help</b-button>
   <help id="15" />
</div>
</h1>
<div role="alert" aria-live="polite" aria-atomic="true" class="alert alert-info"><!----><h4>Messege</h4> This is a trial registration. You can select a course and choose or predict your grade to see how it’ll affect your current CGPA</div>
<Registration/>

   <div class="text-right col-md-12 float-right mt-3 mb-3"> <button class="btn btn-primary mr-2" @click="adviser">Back to Adviser</button></div>
<div class="clearfix"></div>

</div>
</template>

<script>
import Registration from "../../../components/academic/Registration.vue";
import Help from '../../../components/Help.vue';


export default {
  components: {
   Registration,
    Help
  },
  beforeCreate: function() {
        document.body.className = 'iner';
    },
     methods: {
    adviser() {
     
      this.$router.push("/Adviser");
    },
   },
  created() {
  }
};
</script>

<style scoped>
.help {
    color: #fff;
    background-color: #ff8600;
    /* padding: 2px 16px; */
}

</style>